import { render, staticRenderFns } from "./sale_details.vue?vue&type=template&id=1ca2e2dc"
import script from "./sale_details.vue?vue&type=script&lang=js"
export * from "./sale_details.vue?vue&type=script&lang=js"
import style0 from "./sale_details.vue?vue&type=style&index=0&id=1ca2e2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports